import { ActionCreator, createAction, props, Action } from '@ngrx/store';

import { ActionErrorBase } from '../../models/object';
import { LoadSearchActionInfo, LoadSearchActionSuccessInfo } from '../../models/search';

import { DropdownIdActionInfo } from './dropdown';

const createSearchClearAction = (type: any) => {
  if (String.isNullOrEmpty(type)) {
    return null;
  }
  return createAction(type, props<DropdownIdActionInfo>());
};
const createLoadSearchAction = (type: any) => {
  if (String.isNullOrEmpty(type)) {
    return null;
  }
  return createAction(type, props<LoadSearchActionInfo>());
};
const createLoadSearchSuccessAction = (type: any) => {
  if (String.isNullOrEmpty(type)) {
    return null;
  }
  return createAction(type, props<LoadSearchActionSuccessInfo>());
};
const createLoadSearchFailAction = (type: any) => {
  if (String.isNullOrEmpty(type)) {
    return null;
  }
  return createAction(type, props<ActionErrorBase>());
};

export enum SearchActionTypes {
  ClearSearch = 0,
  LoadSearch = 1,
  LoadSearchSuccess = 2,
  LoadSearchFail = 3
}

export const populateDefaultSearchActions = (actionMap: Map<number, string>) =>
  new DefaultSearchActionConverter({
    clearSearch: createSearchClearAction(actionMap.get(SearchActionTypes.ClearSearch)),
    loadSearch: createLoadSearchAction(actionMap.get(SearchActionTypes.LoadSearch)),
    loadSearchSuccess: createLoadSearchSuccessAction(actionMap.get(SearchActionTypes.LoadSearchSuccess)),
    loadSearchFail: createLoadSearchFailAction(actionMap.get(SearchActionTypes.LoadSearchFail))
  });

export class DefaultSearchActionConverter {
  constructor(
    private _actions: {
      clearSearch?: ActionCreator<any, (props: DropdownIdActionInfo) => DropdownIdActionInfo & Action<string>>;
      loadSearch?: ActionCreator<any, (props: LoadSearchActionInfo) => LoadSearchActionInfo & Action<string>>;
      loadSearchSuccess?: ActionCreator<any, (props: LoadSearchActionSuccessInfo) => LoadSearchActionSuccessInfo & Action<string>>;
      loadSearchFail?: ActionCreator<any, (props: ActionErrorBase<any>) => ActionErrorBase<any> & Action<string>>;
    }
  ) {}
  get clearSearch() {
    return this._actions.clearSearch;
  }
  get loadSearch() {
    return this._actions.loadSearch;
  }
  get loadSearchSuccess() {
    return this._actions.loadSearchSuccess;
  }
  get loadSearchFail() {
    return this._actions.loadSearchFail;
  }
}
